import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';

export const LicenseHolderContainer = styled(Flex)`
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 60px;

  @media ${device.laptop} {
    margin-bottom: 160px;
  }
`;

export const LicenseHolderBox = styled(Flex)`
  width: 47%;
  border: 1px solid #EDEDED;
  padding: 40px 50px;
  border-radius: 12px;
  margin-bottom: 40px;
  
  @media ${device.mobileS} {
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  @media ${device.laptop} {
    width: 47%;
  }
`;

export const LicenseCount = styled(Flex)`
  justify-content: center;
  align-items: center;
  height: 93px;
  width: 93px;
  border: 2px solid #EDEDED;
  border-radius: 50%;
  margin-right: 40px;

  p{
    color: #00BF71;
  }

  @media ${device.mobileS} {
    height: 70px;
  }
  
  @media ${device.tablet} {
    height: 93px;
  }
`;

export const LicenseDesc = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap
  h5{
    color: #949494;
  }
  
  @media ${device.mobileS} {
    height: auto;

    h3{
      font-size: 26px;
    }

    h5{
      font-size: 16px;
    }
  }

  @media ${device.tablet} {
    height: 93px;
  }
`;
